import { useQuery } from 'react-query'
import { getBackendUrl } from './url'
import { DEFAULT_LANG } from './i18n'

const ICON_ROOT = '/icons_output/'
const EMPTY = {}

// Unit types that never belong in the military unit lists
const NON_MILITARY_TYPES = ['worker', 'worker_elephant', 'yatai', 'trade_cart', 'naval_trade_ship', 'gaia', 'animal', 'building']

const fetchPbgidIcons = async () => {
	const res = await fetch(`${getBackendUrl()}/api/config/pbgid-icons`)
	return res.json()
}

/** pbgid -> { icon, screen_name, unit_type_list } from server/store/pbgid-icons.json, fetched once and shared by every component */
export function usePbgidIcons() {
	const { data } = useQuery('pbgidIcons', fetchPbgidIcons, { staleTime: Infinity, cacheTime: Infinity })
	return data ?? EMPTY
}

/** "races/common/units/archer_2.png" -> "/icons_output/races/common/units/archer_2.png" */
export function toIconUrl(icon) {
	return icon ? ICON_ROOT + icon : null
}

/** Public url of the icon for a pbgid, null when unknown */
export function getPbgidIcon(pbgidIcons, pbgid) {
	return toIconUrl(pbgidIcons?.[pbgid]?.icon)
}

/** In game name of a pbgid in the given language, falls back to English, null when unknown */
export function getPbgidName(pbgidIcons, pbgid, lang = DEFAULT_LANG) {
	const names = pbgidIcons?.[pbgid]?.screen_name
	return names?.[lang] || names?.[DEFAULT_LANG] || null
}

export function getPbgidTypes(pbgidIcons, pbgid) {
	return pbgidIcons?.[pbgid]?.unit_type_list ?? []
}

/** Every pbgid that has at least one of the given unit types */
export function getPbgidsByType(pbgidIcons, types) {
	return Object.entries(pbgidIcons ?? EMPTY)
		.filter(([, entry]) => entry.unit_type_list.some((type) => types.includes(type)))
		.map(([pbgid]) => Number(pbgid))
}

/** Military units only, so no villagers, traders, fishing boats, buildings, techs or sheep */
export function isMilitaryUnit(pbgidIcons, pbgid) {
	const types = getPbgidTypes(pbgidIcons, pbgid)
	if (!types.length) return false

	// The Atabeg is typed as a trade camel but is a combat unit
	if (types.includes('cavalry') && !types.includes('building')) return true

	return !types.some((type) => NON_MILITARY_TYPES.includes(type))
}
